var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalStorageToggleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "localStorageToggleIcon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "localStorageToggleIcon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GitHubLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "GitButton",
    d: "M0 29C0 12.9837 12.9837 0 29 0V0C45.0163 0 58 12.9837 58 29V29C58 45.0163 45.0163 58 29 58V58C12.9837 58 0 45.0163 0 29V29Z",
    fill: "#FFAEA6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 123",
    d: "M13.2386 24.0212C13.51 22.1218 15.1367 20.7109 17.0554 20.7109H40.1946C42.1133 20.7109 43.74 22.1218 44.0113 24.0212L45.6213 35.291C45.9531 37.6136 44.1508 39.6917 41.8046 39.6917H15.4454C13.0991 39.6917 11.2969 37.6137 11.6287 35.291L13.2386 24.0212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 125",
    d: "M17.7053 18.8461C17.7469 18.3674 18.1476 18 18.6281 18H38.6219C39.1024 18 39.5031 18.3674 39.5447 18.8461L40.7394 32.5848C40.7864 33.126 40.3598 33.5913 39.8165 33.5913H17.4335C16.8902 33.5913 16.4635 33.126 16.5106 32.5848L17.7053 18.8461Z",
    fill: "#FFAEA6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 126",
    d: "M18.9089 18.8443C18.9514 18.3664 19.3518 18 19.8316 18H37.4184C37.8982 18 38.2986 18.3664 38.3411 18.8443L39.3815 30.5493C39.4297 31.0912 39.0028 31.5577 38.4588 31.5577H18.7912C18.2472 31.5577 17.8203 31.0912 17.8685 30.5493L18.9089 18.8443Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 127",
    x: 16.4231,
    y: 35.625,
    width: 2.71154,
    height: 4.06731,
    fill: "#FFAEA6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 128",
    x: 20.4904,
    y: 35.625,
    width: 2.71154,
    height: 4.06731,
    fill: "#FFAEA6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 129",
    x: 24.5577,
    y: 35.625,
    width: 2.71154,
    height: 4.06731,
    fill: "#FFAEA6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalStorageToggleIcon);
export default __webpack_public_path__ + "static/media/localStorageToggleIcon.b2ba7bd1a0632a09e92be802227431e0.svg";
export { ForwardRef as ReactComponent };